
<template>
    <div class="templete_box">
        <div class="crumbsNav no_print clearfix">
            <div :class="['navSon',tab==1?'navSonChecked':'']" @click="changeTab(1)">
                打印设置
            </div>
            <div :class="['navSon',tab==14?'navSonChecked':'']" @click="changeTab(14)">
                合同设置
            </div>
            <div :class="['navSon',tab==2?'navSonChecked':'']" @click="changeTab(2)">
                标签设置
            </div>
            <div :class="['navSon',tab==3?'navSonChecked':'']" @click="changeTab(3)">
                锁货设置
            </div>
            <div :class="['navSon',tab==4?'navSonChecked':'']" @click="changeTab(4)">
                归属设置
            </div>
            <div :class="['navSon',tab==18?'navSonChecked':'']" @click="changeTab(18)">
                仓储费设置
            </div>
            <!-- <div :class="['navSon',tab==5?'navSonChecked':'']" @click="changeTab(5)">
                显示设置
            </div> -->
            <div :class="['navSon',tab==6?'navSonChecked':'']" @click="changeTab(6)">
                折扣设置
            </div>
            <div :class="['navSon',tab==7?'navSonChecked':'']" @click="changeTab(7)">
                清空设置
            </div>
            <div :class="['navSon',tab==8?'navSonChecked':'']" @click="changeTab(8)">
                公司设置
            </div>
            <div :class="['navSon',tab==9?'navSonChecked':'']" @click="changeTab(9)">
                检尺设置
            </div>
            <div :class="['navSon',tab==10?'navSonChecked':'']" @click="changeTab(10)">
                序号设置
            </div>
            <div :class="['navSon',tab==11?'navSonChecked':'']" @click="changeTab(11)">
                模板设置
            </div>
            <div :class="['navSon',tab==12?'navSonChecked':'']" @click="changeTab(12)">
                超方设置
            </div>
            <div :class="['navSon',tab==13?'navSonChecked':'']" @click="changeTab(13)">
                定价设置
            </div>
            <div v-if="module.indexOf(',finance-order,')!=-1" :class="['navSon',tab==15?'navSonChecked':'']" @click="changeTab(15)">
                融资预警
            </div>
            <div v-if="is_super==1" :class="['navSon',tab==16?'navSonChecked':'']" @click="changeTab(16)">
                欠款审批设置
            </div>
            <div v-if="module.indexOf(',setting-advanced-backup,')!=-1" :class="['navSon',tab==17?'navSonChecked':'']" @click="changeTab(17)">
                数据库备份
            </div>
            <div :class="['navSon',tab==19?'navSonChecked':'']" @click="changeTab(19)">
                组装拆卸设置
            </div>
            <div :class="['navSon',tab==20?'navSonChecked':'']" @click="changeTab(20)">
                小数点设置
            </div>
        </div>
        <printSet v-if="tab == 1"></printSet>
        <settingLabel v-if="tab == 2"></settingLabel>
        <settingLockSettings v-if="tab == 3"></settingLockSettings>
        <settingCustomer v-if="tab == 4"></settingCustomer>
        <showSet v-if="tab ==5"></showSet>
        <discountSet v-if="tab == 6"></discountSet>
        <systemClear v-if="tab == 7"></systemClear>
        <companySet v-if="tab == 8"></companySet>
        <rulerSet v-if="tab == 9"></rulerSet>
        <indexNumber v-if="tab == 10"></indexNumber>
        <excelSet v-if="tab == 11"></excelSet>
        <cubeOverflow v-if="tab == 12"></cubeOverflow>
        <defindPrice v-if="tab == 13"></defindPrice>
        <contractPrint v-if="tab == 14"></contractPrint>
        <financingWarning v-if="tab == 15"></financingWarning>
        <arrearsSet v-if="tab == 16"></arrearsSet>
        <backups v-if="tab == 17"></backups>
        <storageFee v-if="tab == 18"></storageFee>
        <assembleCubic v-if="tab == 19"></assembleCubic>
        <decimalSetup v-if="tab == 20"></decimalSetup>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                module:localStorage.dw_erp_power_code,
                is_super:localStorage.dw_erp_is_super,
                tab : 1
            }
        },
        created(){
        },
        methods:{
            changeTab(tab){
                //this.tab=tab;
                this.$set(this,"tab",tab);
            }
        }
    }
</script>
<style scoped>
    .navSon{padding:0 0px;font-size: 14px;line-height: 30px;float: left;margin-right:50px;cursor: pointer;box-sizing: border-box;height:33px;}
    .navSonChecked{border-bottom:3px solid #b21111;}
    .navSon:last-child{margin-right:0;}
</style>